import React from "react";
import CheckCircle from "@mui/icons-material/CheckCircle";
import { useTheme } from "@mui/material";
import { SvgIconProps } from "@mui/material/SvgIcon/SvgIcon";

/** A green check mark icon to show successes */
export const CheckIcon = (props: SvgIconProps) => {
  const theme = useTheme();
  return <CheckCircle htmlColor={theme.palette.success.main} {...props} />;
};
